const state = {
  isAuthenticated: false,
  profile: {},
  config: {}
}

export default state
